import { render, staticRenderFns } from "./StepConsultations.vue?vue&type=template&id=51596210&scoped=true&"
import script from "./StepConsultations.vue?vue&type=script&lang=js&"
export * from "./StepConsultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51596210",
  null
  
)

export default component.exports